"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreUsersByIdPasswordPatchAsyncSlice = void 0;
const _api_1 = require("../../../../api/index.js");
const sonar_analytics_1 = require("@sonar-software/sonar-analytics");
const xuder_1 = require("@sonar-software/xuder");
exports.coreUsersByIdPasswordPatchAsyncSlice = (0, xuder_1.createPatchAsyncSlice)({
    additionalRequestSteps: [
        {
            actionHandler: (0, sonar_analytics_1.createLogSaga)(sonar_analytics_1.AMPLITUDE_EVENT.PASSWORD_UPDATED),
            type: xuder_1.SagaYieldType.Every
        }
    ],
    name: 'CoreUsersByIdPassword',
    receive: false,
    request: true,
    requestHandler: _api_1.patchUserPassword
});
//# sourceMappingURL=patch.js.map